import React, { useEffect, useState } from "react";
import axios from "axios";
import API from "./config/API";

import { useNavigate } from "react-router-dom";

function FoodMenuList() {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const [foodMenuList, setFoodMenuList] = useState([]);

  const [selectedDay, setSelectedDay] = useState("");

  useEffect(() => {
    getFoodMenuDetails();
  }, []);

  const getFoodMenuDetails = async () => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user || !user.jwtToken) {
      alert("Session Expired. Please login again.");
      navigate("/");
      return;
    }

    try {
      const response = await axios.get(
        `${API.V1}/foodMenu/getFoodMenuDetails/${user.emailId}`,
        {
          headers: {
            Authorization: `Bearer ${user.jwtToken}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.statusCode === 200) {
        setFoodMenuList(response.data.data);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.clear();
        alert("Session Expired. Please login again.");

        setTimeout(() => {
          navigate("/");
        }, 1000);
      } else {
        console.error("Error fetching food menu:", error);
      }
    }
  };

  const handleEdit = (food) => {
    navigate("/foodMenuPerDay", {
      state: {
        id: food.id,
        food: food,
      },
    });
  };

  const getCardColor = (type) => {
    switch (type) {
      case "BREAK_FAST":
        return "#FFF8E1";
      case "LUNCH":
        return "#E8F5E9";
      case "DINNER":
        return "#E3F2FD";
      default:
        return "#ffffff";
    }
  };

  const getIcon = (type) => {
    switch (type) {
      case "BREAK_FAST":
        return "🍳";
      case "LUNCH":
        return "🍛";
      case "DINNER":
        return "🍽️";
      default:
        return "🍴";
    }
  };

  return (
    <>
      <style>{styles}</style>

      <div className="food-page">
        <div className="page-header">
          <div className="filter-box">
            <label>Select Food Day</label>

            <select
              value={selectedDay}
              onChange={(e) => setSelectedDay(e.target.value)}
            >
              <option value="">All Days</option>

              {foodMenuList.map((day) => (
                <option key={day.foodDayId} value={day.foodDay}>
                  {day.foodDay}
                </option>
              ))}
            </select>
          </div>

          <h1 className="page-title">🍽 Weekly Food Menu</h1>

          <div className="header-btn">
            <button
              className="add-menu-btn"
              onClick={() => navigate("/foodMenuPerDay")}
            >
              ➕ Food Menu
            </button>
          </div>
        </div>

        {foodMenuList.length === 0 ? (
          <div className="no-data">No Food Menu Available</div>
        ) : (
          foodMenuList
            .filter((day) => selectedDay === "" || day.foodDay === selectedDay)
            .map((day) => (
              <div className="day-card" key={day.foodDayId}>
                <div className="day-header">
                  <div>
                    <h2>{day.foodDay}</h2>
                    <span>Created : {day.createdDate.replace("T", " ")}</span>
                  </div>

                  <div className="status-action">
                    <span
                      className={
                        day.foodDayStatus ? "status-active" : "status-inactive"
                      }
                    >
                      {day.foodDayStatus ? "ACTIVE" : "INACTIVE"}
                    </span>

                    <button
                      className="edit-btn"
                      onClick={() => handleEdit(day)}
                    >
                      ✏️ Edit
                    </button>
                  </div>
                </div>

                <div className="food-grid">
                  {day.foodTypesPerDay.map((food) => (
                    <div
                      className="food-card"
                      key={food.menuId}
                      style={{
                        background: getCardColor(food.foodMenuTypePerDay),
                      }}
                    >
                      <div className="food-title">
                        <div>
                          {getIcon(food.foodMenuTypePerDay)}{" "}
                          {food.foodMenuTypePerDay.replace("_", " ")}
                        </div>

                        <div className="food-time">
                          ⏰{" "}
                          {food.foodStartTime && food.foodEndTime
                            ? `${food.foodStartTime} - ${food.foodEndTime}`
                            : "Time Not Set"}
                        </div>
                      </div>

                      <div className="food-section">
                        <label>Main Menu</label>

                        <div className="food-items">{food.foodMenu}</div>
                      </div>

                      <div className="food-section">
                        <label>Extra Food</label>

                        <div className="food-items">
                          {food.extraFood || "-"}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))
        )}
      </div>
    </>
  );
}

export default FoodMenuList;

const styles = `

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", sans-serif;
}

body {
  background: #eef2f7;
}

/* ===========================
   PAGE
=========================== */

.food-page {
  min-height: 100vh;
  padding: 35px;
  background: linear-gradient(135deg, #eef4ff, #f9fbff);
}

/* ===========================
   HEADER
=========================== */

.page-header {
  display: grid;
  grid-template-columns: 260px 1fr 260px;
  align-items: end;
  gap: 20px;
  margin-bottom: 35px;
}

.page-title {
  text-align: center;
  font-size: 38px;
  font-weight: 700;
  color: #1e3a8a;
}

.status-action{
    display:flex;
    align-items:center;
    gap:12px;
}

.food-card-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom:15px;
}

.edit-btn{
    background:#2563eb;
    color:#fff;
    border:none;
    padding:8px 16px;
    border-radius:8px;
    cursor:pointer;
    font-size:15px;
    font-weight:600;
    transition:.3s;
}

.edit-btn:hover{
    background:#1d4ed8;
    transform:translateY(-2px);
}

/* ===========================
   DROPDOWN
=========================== */

.filter-box {
  display: flex;
  flex-direction: column;
}

.filter-box label {
  margin-bottom: 8px;
  font-size: 17px;
  font-weight: 700;
  color: #1e3a8a;
}

.filter-box select {
  padding: 12px 15px;
  border-radius: 12px;
  border: 2px solid #2563eb;
  background: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: .3s;
}

.filter-box select:hover {
  border-color: #1d4ed8;
}

.filter-box select:focus {
  outline: none;
  border-color: #1d4ed8;
  box-shadow: 0 0 10px rgba(37, 99, 235, .25);
}

/* ===========================
   BUTTON
=========================== */

.header-btn {
  display: flex;
  justify-content: flex-end;
}

.add-menu-btn {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 13px 20px;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
  transition: .3s;
  box-shadow: 0 8px 18px rgba(16, 185, 129, .35);
}

.add-menu-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(16, 185, 129, .45);
}

/* ===========================
   DAY CARD
=========================== */

.day-card {
  background: white;
  border-radius: 18px;
  margin-bottom: 35px;
  padding: 25px;
  box-shadow: 0 10px 25px rgba(0,0,0,.08);
  transition: .35s;
}

.day-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 18px 35px rgba(0,0,0,.15);
}

/* ===========================
   DAY HEADER
=========================== */

.day-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 18px;
  margin-bottom: 25px;
}

.day-header h2 {
  color: #2563eb;
  font-size: 30px;
  font-weight: 700;
}

.day-header span {
  color: #64748b;
  font-size: 15px;
  margin-top: 5px;
  display: block;
}

/* ===========================
   STATUS
=========================== */

.status-active {
  background: #22c55e;
  color: white;
  padding: 8px 18px;
  border-radius: 30px;
  font-weight: bold;
}

.status-inactive {
  background: #ef4444;
  color: white;
  padding: 8px 18px;
  border-radius: 30px;
  font-weight: bold;
}

/* ===========================
   FOOD GRID
=========================== */

.food-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

/* ===========================
   FOOD CARD
=========================== */

.food-card {
  background: #f8fbff;
  border-radius: 18px;
  padding: 22px;
  border: 1px solid #dbeafe;
  transition: .35s;
  box-shadow: 0 5px 15px rgba(0,0,0,.06);
}

.food-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 15px 30px rgba(0,0,0,.15);
}

.food-title {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  color: #2563eb;
  margin-bottom: 18px;
  padding-bottom: 10px;
  border-bottom: 2px dashed #cbd5e1;
}

/* ===========================
   FOOD SECTION
=========================== */

.food-section {
  margin-top: 18px;
}

.food-section label {
  display: block;
  font-size: 17px;
  font-weight: bold;
  color: #334155;
  margin-bottom: 8px;
}

.food-items {
  background: white;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  padding: 14px;
  min-height: 90px;
  line-height: 1.8;
  font-size: 16px;
  color: #475569;
  white-space: pre-wrap;
  word-break: break-word;
}

.food-time {
  margin-top: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #475569;
  background: rgba(255, 255, 255, 0.7);
  padding: 6px 10px;
  border-radius: 8px;
  display: inline-block;
}

/* ===========================
   NO DATA
=========================== */

.no-data {
  margin-top: 80px;
  text-align: center;
  font-size: 24px;
  color: red;
  font-weight: bold;
}

/* ===========================
   RESPONSIVE
=========================== */

@media (max-width:1100px) {

  .page-header {
    grid-template-columns: 1fr;
  }

  .page-title {
    text-align: left;
  }

  .header-btn {
    justify-content: flex-start;
  }

  .food-grid {
    grid-template-columns: repeat(2,1fr);
  }

}

@media (max-width:768px) {

  .food-page {
    padding: 18px;
  }

  .page-title {
    font-size: 30px;
  }

  .food-grid {
    grid-template-columns: 1fr;
  }

  .day-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .day-header h2 {
    font-size: 24px;
  }

  .food-title {
    font-size: 21px;
  }

  .food-items {
    font-size: 15px;
  }

  .add-menu-btn {
    width: 100%;
  }

}
`;
